import Swiper, {
  Navigation, Pagination, Autoplay
} from 'swiper';
import 'swiper/swiper-bundle.min.css';

Swiper.use([Navigation, Pagination, Autoplay]);

export function initRStepsBlockSlider() {
  const sliders = document.querySelectorAll('[data-r-steps-block-slider]');

  if (sliders.length) {
    const breakpoint = window.matchMedia('(min-width:1024px)');
    let swiperSteps = [];

    // eslint-disable-next-line
    function breakpointChecker() {
      if (breakpoint.matches === true) {
        if (swiperSteps.length > 0) {
          swiperSteps.forEach((slider) => slider.destroy(true, true));
          swiperSteps = [];
        }
      } else if (breakpoint.matches === false) {
        enableSwiper();
      }
    }

    // eslint-disable-next-line
    function enableSwiper() {
      sliders.forEach((sliderEl) => {
        const slider = new Swiper(sliderEl, {
          slidesPerView : 1,
          spaceBetween  : 16,
          loop          : false,
          speed         : 1000,

          navigation: {
            nextEl : sliderEl.querySelector('.js-swiper-button-next'),
            prevEl : sliderEl.querySelector('.js-swiper-button-prev')
          }
        });

        swiperSteps.push(slider);
      });
    }

    breakpointChecker();

    window.addEventListener('resize', () => {
      breakpointChecker();
    });

    window.dispatchEvent(new Event('resize'));
  }
}
